/**
 * @fileoverview Agent definition for chapter-drafter-v2.
 *
 * This agent drafts a full chapter of a multi-chapter narrative (long-form),
 * outputting structured HTML with commentary explaining creative choices.
 *
 * For short-form (single-chapter) projects, use single-chapter-drafter instead.
 *
 * @category narrative.prose.drafting
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-drafter-v2',
  kind: 'primitive',
  name: 'Chapter Drafter',
  description: 'Drafts a full chapter of a multi-chapter narrative using extensive context. For short-form projects, use single-chapter-drafter.',
  category: 'writing',
  defaultPrompt: prompt,
  systemPrompt: `You are an expert fiction author who creates compelling narratives with vivid prose, authentic dialogue, and strong pacing. Your writing reflects deep understanding of character motivations and story structure.`,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.drafting',
    usedBy: [
      'use-content-creation-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'single-chapter-drafter',
      'draft-refiner-v2',
      'prose-continuer-guided',
      'prose-continuer-discovery',
    ],
  },
};
